import http from '../libs/http'

/*
	NOTICE:
	- every action starts with an underscore
*/

const graphActions: any = {
	//? BIN GRAPH
	async _listBinGraphData({ state, dispatch }: any, data: any) {
		try {
			// console.log(data)
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/bingraph/${data.base64path}/${data.key}`, config)
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v1/bingraph/${data.base64path}/${data.key}`)
			return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _listBinGraphKeys({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const filepath = window.atob(data.filepath)
			// const base64path = data.filepath
			// const resp = await axios.get(env.apiUrl + `/api/v1/bingraphkeys/${base64path}`, config)
			// return resp.data || []
			const base64path = data.filepath
			const resp = await http.getAuth<any>(`/api/v1/bingraphkeys/${base64path}`)
			return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},

	async _binChartData({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(
			// 	env.apiUrl +
			// 		`/api/v1/binchartdata/${data.pcName}/${data.binKey}/${data.yearFrom}/${data.monthFrom}/${data.yearTo}/${data.monthTo}`,
			// 	config,
			// )
			// return resp.data || []
			const resp = await http.getAuth<any>(
				`/api/v1/binchartdata/${data.pcName}/${data.binKey}/${data.yearFrom}/${data.monthFrom}/${data.yearTo}/${data.monthTo}`,
			)
			return resp
		} catch (error: any) {
			throw new Error(await dispatch('_makeErrorMsg', error))
		}
	},
}

export default graphActions
